module.exports = __webpack_public_path__ + "static/media/header-img.bfe6d1a6.svg";